@if (toggleEnabled && darkModeEnabled) {
    <input
        id="dark-mode"
        class="dark-mode-toggle"
        type="checkbox"
        [checked]="darkMode"
        [core-analytics]="{ action: 'Dark mode', label: 'state', value: '' + darkMode }"
        (change)="settings.toggle('isDarkMode')" />
    <label class="dark-mode-label" for="dark-mode">
        <span [ngClass]="{ dark: moonDark }" class="material-symbols-outlined moon">dark_mode</span>
        <span class="material-symbols-outlined sun">light_mode</span>
    </label>
}
